<div class="controller-container">
  <div *ngIf="notFound" class="controller-not-found">{{ 'controller.not_found' | translate }}</div>

  <ng-container *ngIf="controller">
  <div class="controller-header">
    <div class="header-main">
      <div class="title-section border: 1px solid red;">
        <span class="status-indicator">
          <i [class.online]="controller?.online" [class.offline]="!controller?.online"></i>
        </span>
        <div class="controller-info">
          <h2>{{ controller?.name }}
            <span class="via-bus" *ngIf="controller?.online && controller?.directConnected === false"
                  [title]="'controllers.via_bus_hint' | translate">{{ 'controllers.via_bus' | translate }}</span>
          </h2>
          <h3>{{ controller?.description }}</h3>
          <span
            class="detail"
            *ngIf="!controller?.online"
            >{{ 'controller.last_seen' | translate }}: {{ controller?.lastSeen | date: 'dd.MM.yyyy HH:mm:ss' }}</span
          >
        </div>
      </div>
      <div class="action-buttons">
        <div *ngIf="!isOutputsOnly">
          <button class="settings-btn" (click)="onMenuInfo()">
            <img src="assets/icons/info.svg" width="28" height="28" [alt]="'controller.info.title' | translate" />
          </button>
        </div>
        <div *ngIf="canConfigure">
          <button class="settings-btn" (click)="onMenuSettings()">
            <img src="assets/icons/settings.svg" width="28" height="28" [alt]="'controller.menu.settings' | translate" />
          </button>
        </div>
        <div *ngIf="canConfigure">
          <button class="settings-btn" (click)="onMenuScenarios()">
            <img src="assets/icons/scenarios.svg" width="28" height="28" [alt]="'scenario.title' | translate" />
          </button>
        </div>
        <div *ngIf="canConfigure">
          <button class="settings-btn" (click)="onMenuScheduler()">
            <img src="assets/icons/scheduler.svg" width="28" height="28" [alt]="'scheduler.title' | translate" />
          </button>
        </div>
        <div *ngIf="isOwner">
          <button class="settings-btn" (click)="openShare()" [title]="'share.title' | translate">
            <img src="assets/icons/share.svg" width="28" height="28" [alt]="'share.title' | translate" />
          </button>
        </div>
        <div *ngIf="controller?.groupID != null">
          <button class="settings-btn" (click)="onMenuGroup()">
            <img src="assets/icons/group.svg" width="28" height="28" [alt]="'controller.menu.group' | translate" />
          </button>
        </div>
        <div *ngIf="canConfigure">
          <button class="settings-btn" (click)="showLogs()">
            <img src="assets/icons/logs.svg" width="28" height="28" [alt]="'controller.logs.title' | translate" />
          </button>
        </div>
      </div>
    </div>
  </div>


  <!-- Config sync banner: an edit here does nothing on the controller until it is uploaded,
       and an edit made on the controller itself stays invisible until it is imported. -->
  <div class="config-banner" *ngIf="canConfigure && configState && configState.synced === false && controller?.online">
    <span class="config-banner-text" *ngIf="configState.ahead === 'cloud'">
      {{ 'controller.config.dirty' | translate }}
    </span>
    <span class="config-banner-text" *ngIf="configState.ahead === 'device'">
      {{ 'controller.config.device_ahead' | translate }}
    </span>
    <span class="config-banner-text" *ngIf="configState.ahead === 'unknown'">
      {{ 'controller.config.unknown' | translate }}
    </span>
    <span class="config-banner-actions">
      <button class="btn-primary" (click)="showUploadConfirm = true">{{ 'controller.config.upload' | translate }}</button>
      <button class="btn-secondary" *ngIf="configState.ahead === 'device'"
              (click)="showImportConfirm = true">{{ 'controller.config.import' | translate }}</button>
    </span>
  </div>

  <!-- Outputs-only view: what a friend with OUTPUTS access sees — this controller's outputs, or
       the whole bus group's when the group toggle is on (only devices shared with them appear). -->
  <div class="plain-view" *ngIf="!isUni && isOutputsOnly">
    <h3 class="section-title">{{ 'controller.tab.outputs' | translate }}</h3>
    <div class="outputs-container">
      <ng-container *ngFor="let outputGroup of outputsGroups | keyvalue; trackBy: trackByGroupKey">
        <div class="slave-divider" *ngIf="showOutputGroupDividers">
          <span class="slave-label">{{ 'controller.group' | translate }}: {{ outputGroup.key }}</span>
        </div>
        <app-output-card *ngFor="let output of outputGroup.value; trackBy: trackByOutput"
                        [output]="output"
                        [ngClass]="output.state"
                        [mac]="controller?.mac"
                        [node]="output.node">
        </app-output-card>
      </ng-container>
    </div>
  </div>

  <!-- Uni-family controller (water / heater / fan): channel dashboard -->
  <app-uni-dashboard *ngIf="isUni"
    [controller]="controller"
    [canConfigure]="canConfigure">
  </app-uni-dashboard>

  <!-- Mobile Tabs -->
  <div class="mobile-tabs" *ngIf="!isUni && theme === 'standard' && !isOutputsOnly">
    <button class="tab-button" [class.active]="activeTab === 'outputs'" (click)="setActiveTab('outputs')">
      {{ 'controller.tab.outputs' | translate }}
    </button>
    <button class="tab-button" [class.active]="activeTab === 'inputs'" (click)="setActiveTab('inputs')">
      {{ 'controller.tab.inputs' | translate }}
    </button>
    <button class="tab-button" *ngIf="hasZigbee"
            [class.active]="activeTab === 'zigbee'" (click)="setActiveTab('zigbee')">
      {{ 'controller.tab.zigbee' | translate }}
    </button>
    <button class="tab-button" [class.active]="activeTab === 'buttons'" (click)="setActiveTab('buttons')">
      {{ 'controller.tab.buttons' | translate }}
    </button>
  </div>

  <!-- Desktop View -->
  <div class="desktop-view" *ngIf="!isUni && theme === 'standard' && !isOutputsOnly">
    <h3 class="section-title">{{ 'controller.tab.outputs' | translate }}</h3>
    <div class="outputs-container">
      <ng-container *ngFor="let outputGroup of outputsGroups | keyvalue; trackBy: trackByGroupKey">
        <div class="slave-divider" *ngIf="showOutputGroupDividers">
          <span class="slave-label">{{ 'controller.group' | translate }}: {{ outputGroup.key }}</span>
        </div>
        <app-output-card *ngFor="let output of outputGroup.value; trackBy: trackByOutput"
                        [output]="output"
                        [ngClass]="output.state"
                        [mac]="controller?.mac"
                        [node]="output.node">
        </app-output-card>
      </ng-container>
    </div>

    <h3 class="section-title">{{ 'controller.tab.inputs' | translate }}</h3>
    <div class="outputs-container">
      <ng-container *ngFor="let inputGroup of inputsGroups | keyvalue; trackBy: trackByGroupKey">
        <div class="slave-divider" *ngIf="showInputGroupDividers">
          <span class="slave-label">{{ 'controller.group' | translate }}: {{ inputGroup.key }}</span>
        </div>
        <app-input-card *ngFor="let input of inputGroup.value; trackBy: trackByInput"
                        [input]="input"
                        [ngClass]="input.state"
                        [mac]="controller?.mac">
        </app-input-card>
      </ng-container>
    </div>

    <h3 class="section-title">{{ 'controller.tab.buttons' | translate }}</h3>
    <div class="outputs-container">
      <ng-container *ngFor="let buttonGroup of buttonsGroups | keyvalue;">
        <div class="slave-divider" *ngIf="showButtonGroupDividers">
          <span class="slave-label">{{ 'controller.group' | translate }}: {{ buttonGroup.key }}</span>
        </div>
        <app-button-card *ngFor="let input of buttonGroup.value; trackBy: trackByOutput"
                        [input]="input"                         
                        [mac]="controller?.mac"
                        [node]="input.node">
        </app-button-card>
      </ng-container>
    </div>

    <h3 class="section-title" *ngIf="hasZigbee">{{ 'controller.zigbee.section' | translate }}</h3>
    <div class="zigbee-toolbar" *ngIf="hasZigbee">
      <button *ngIf="!pairing" (click)="startPairing()">+ {{ 'controller.zigbee.add_sensor' | translate }}</button>
      <span *ngIf="pairing" class="pairing">
        {{ 'controller.zigbee.searching' | translate: { seconds: pairingRemaining } }}
        <button (click)="stopPairing()">{{ 'common.stop' | translate }}</button>
      </span>
      <span class="muted" *ngIf="!zigbeeDevices.length && !pairing">
        {{ 'controller.zigbee.none_paired' | translate }}
      </span>
    </div>
    <div class="outputs-container" *ngIf="hasZigbee">
      <app-zigbee-card *ngFor="let dev of zigbeeDevices"
                       [device]="dev"
                       [mac]="controller?.mac"
                       [ruleCount]="rulesFor(dev.ieee)">
      </app-zigbee-card>
    </div>
  </div>

  <!-- Mobile View -->
  <div class="mobile-view" *ngIf="!isUni && theme === 'standard' && !isOutputsOnly">
    <div class="tab-content"
         [ngClass]="{
           'active': activeTab === 'outputs',
           'slide-right': getTabAnimationClass('outputs') === 'slide-right',
           'slide-left': getTabAnimationClass('outputs') === 'slide-left'
         }">
      <div class="outputs-container">
        <ng-container *ngFor="let outputGroup of outputsGroups | keyvalue; trackBy: trackByGroupKey">
          <div class="slave-divider" *ngIf="showOutputGroupDividers">
            <span class="slave-label">{{ 'controller.group' | translate }}: {{ outputGroup.key }}</span>
          </div>
          <app-output-card *ngFor="let output of outputGroup.value; trackBy: trackByOutput"
                          [output]="output"
                          [ngClass]="output.state"
                          [mac]="controller?.mac"
                          [node]="output.node">
          </app-output-card>
        </ng-container>
      </div>
    </div>

    <div class="tab-content" 
         [ngClass]="{
           'active': activeTab === 'inputs',
           'slide-right': getTabAnimationClass('inputs') === 'slide-right',
           'slide-left': getTabAnimationClass('inputs') === 'slide-left'
         }">

      <div class="inputs-container">
        <ng-container *ngFor="let inputGroup of inputsGroups | keyvalue; trackBy: trackByGroupKey">
          <div class="slave-divider" *ngIf="showInputGroupDividers">
            <span class="slave-label">{{ 'controller.group' | translate }}: {{ inputGroup.key }}</span>
          </div>  
          <app-input-card *ngFor="let input of inputGroup.value; trackBy: trackByInput"
                          [input]="input" 
                          [ngClass]="input.state"
                          [mac]="controller?.mac">
          </app-input-card>
        </ng-container>    
      </div>
    </div>
   
    <div class="tab-content" 
         [ngClass]="{
           'active': activeTab === 'buttons',
           'slide-right': getTabAnimationClass('buttons') === 'slide-right',
           'slide-left': getTabAnimationClass('buttons') === 'slide-left'
         }">
      <div class="buttons-container">
        <ng-container *ngFor="let buttonGroup of buttonsGroups | keyvalue;">
          <div class="slave-divider" *ngIf="showButtonGroupDividers">
            <span class="slave-label">{{ 'controller.group' | translate }}: {{ buttonGroup.key }}</span>
          </div>
          <app-button-card *ngFor="let input of buttonGroup.value; trackBy: trackByOutput"
                          [input]="input" 
                          [mac]="controller?.mac"
                          [node]="input.node">
          </app-button-card>
        </ng-container>  
      </div>
    </div>

    <div class="tab-content" *ngIf="hasZigbee"
         [ngClass]="{
           'active': activeTab === 'zigbee',
           'slide-right': getTabAnimationClass('zigbee') === 'slide-right',
           'slide-left': getTabAnimationClass('zigbee') === 'slide-left'
         }">
      <div class="zigbee-toolbar">
        <button *ngIf="!pairing" (click)="startPairing()">+ {{ 'controller.zigbee.add_sensor' | translate }}</button>
        <span *ngIf="pairing" class="pairing">
          {{ 'controller.zigbee.searching_short' | translate: { seconds: pairingRemaining } }}
          <button (click)="stopPairing()">{{ 'common.stop' | translate }}</button>
        </span>
      </div>
      <div class="outputs-container">
        <app-zigbee-card *ngFor="let dev of zigbeeDevices"
                         [device]="dev"
                         [mac]="controller?.mac"
                         [ruleCount]="rulesFor(dev.ieee)">
        </app-zigbee-card>
      </div>
    </div>
  </div>
 
  <!-- Light theme: just the outputs of every controller on the bus (group). -->
  <div class="desktop-view light-view" *ngIf="!isUni && theme === 'light' && !isOutputsOnly">
    <h3 class="section-title">{{ 'controller.lights' | translate }}</h3>
    <div class="outputs-container">
      <ng-container *ngFor="let outputGroup of outputsGroups | keyvalue; trackBy: trackByGroupKey">
        <div class="slave-divider" *ngIf="showOutputGroupDividers">
          <span class="slave-label">{{ outputGroup.key }}</span>
        </div>
        <app-output-card *ngFor="let output of outputGroup.value; trackBy: trackByOutput"
                        [output]="output"
                        [ngClass]="output.state"
                        [mac]="controller?.mac"
                        [node]="output.node">
        </app-output-card>
      </ng-container>
    </div>
  </div>

  <!-- Irrigation theme: scenario dashboard + buttons + "skip today". -->
  <div class="irrigation-view" *ngIf="!isUni && theme === 'irrigation' && !isOutputsOnly">
    <app-irrigation-dashboard
        [controller]="controller"
        [runningEvent]="scenarioRunning"
        [buttonsGroups]="buttonsGroups">
    </app-irrigation-dashboard>
  </div>

  </ng-container>

  <!-- Share access modal (owner only) -->
  <div class="popup-overlay" *ngIf="showShareModal" (click)="showShareModal = false">
    <div class="popup-content" (click)="$event.stopPropagation()">
      <div class="popup-header">
        <h3>{{ 'share.title' | translate }}</h3>
        <button class="close-button" (click)="showShareModal = false">
          <img src="assets/icons/close.svg" width="20" height="20" [alt]="'common.close' | translate" />
        </button>
      </div>
      <div class="popup-body share-body">
        <div class="share-create">
          <label class="share-field">{{ 'share.level' | translate }}
            <select [(ngModel)]="shareLevel">
              <option value="OUTPUTS">{{ 'share.level.outputs' | translate }}</option>
              <option value="FULL">{{ 'share.level.full' | translate }}</option>
            </select>
          </label>
          <button class="share-btn primary" [disabled]="shareGenerating" (click)="createShareLink()">
            {{ (shareGenerating ? 'share.creating' : 'share.create_link') | translate }}
          </button>
        </div>

        <div class="share-link" *ngIf="shareLink">
          <p class="muted">{{ 'share.link_hint' | translate }}</p>
          <div class="link-row">
            <input class="share-input" readonly [value]="shareLink" />
            <button class="share-btn secondary" (click)="copyLink()">
              {{ (copied ? 'common.copied' : 'common.copy') | translate }}
            </button>
          </div>
          <qrcode [qrdata]="shareLink" [width]="180" [errorCorrectionLevel]="'M'" [margin]="1"></qrcode>
        </div>

        <div class="share-list" *ngIf="shares.length">
          <h4>{{ 'share.who_has_access' | translate }}</h4>
          <div class="share-row" *ngFor="let s of shares">
            <span class="share-name">{{ s.name }}</span>
            <select class="share-select" [ngModel]="s.level" (ngModelChange)="changeShareLevel(s.userUuid, $event)">
              <option value="OUTPUTS">{{ 'share.level.outputs' | translate }}</option>
              <option value="FULL">{{ 'share.level.full' | translate }}</option>
            </select>
            <button class="share-btn danger" (click)="revokeShare(s.userUuid)">{{ 'share.revoke' | translate }}</button>
          </div>
        </div>
        <p class="muted" *ngIf="!shares.length">{{ 'share.nobody' | translate }}</p>
      </div>
    </div>
  </div>

  <!-- Info Popup -->
  <div class="popup-overlay" *ngIf="showInfoPopup" (click)="showInfoPopup = false">
    <div class="popup-content" (click)="$event.stopPropagation()">
      <div class="popup-header">
        <h3>{{ 'controller.info.title' | translate }}</h3>
        <button class="close-button" (click)="showInfoPopup = false">
          <img src="assets/icons/close.svg" width="20" height="20" [alt]="'common.close' | translate" />
        </button>
      </div>
      <div class="popup-body">
        <div class="status-info">
          <p><span>{{ 'common.name' | translate }}</span> <span>{{ controller?.name }}</span></p>
          <p><span>{{ 'common.description' | translate }}</span> <span>{{ controller?.description }}</span></p>
          <p><span>{{ 'controller.info.fw_version' | translate }}</span> <span>{{ controller?.info.version }}</span></p>
          <p><span>{{ 'controller.info.config_date' | translate }}</span> <span>{{ controller?.info.configDate ? (controller?.info.configDate * 1000 | date: 'dd.MM.yyyy HH:mm:ss') : '—' }}</span></p>
          <p><span>{{ 'controller.info.free_memory' | translate }}</span> <span>{{ controller?.info.freeMemory | number:'1.0-0'}}</span></p>
          <p><span>{{ 'controller.info.uptime' | translate }}</span> <span><ng-container
              *ngIf="uptimeDays(controller?.info.uptimeRaw) as d">{{ 'controller.info.uptime_days' | translate: { days: d } }} </ng-container>{{ getUptimeStr(controller?.info.uptimeRaw) }}</span></p>
          <p><span>{{ 'controller.info.mac' | translate }}</span> <span>{{ controller?.mac }}</span></p>
          <p><span>{{ 'controller.info.eth_ip' | translate }}</span> <span>{{ controller?.info.ethIP }}</span></p>
          <p><span>{{ 'controller.info.wifi_ip' | translate }}</span> <span>{{ controller?.info.wifiIP }}</span></p>
          <p><span>{{ 'controller.info.wifi_rssi' | translate }}</span> <span>{{ controller?.info.wifiRSSI }}</span></p>
          <p><span>{{ 'controller.info.reset_reason' | translate }}</span> <span>{{ resetReasonText | translate }}</span></p>
        </div>
        <div class="popup-actions">
          <button class="popup-action-btn" (click)="showInfo()" [title]="'common.refresh' | translate">
            <img src="assets/icons/refresh.svg" width="20" height="20" [alt]="'common.refresh' | translate" />
            <span>{{ 'common.refresh' | translate }}</span>
          </button>
          <button class="popup-action-btn" (click)="onMenuReboot()" [title]="'controller.reboot' | translate">
            <img src="assets/icons/reboot.svg" width="20" height="20" [alt]="'controller.reboot' | translate" />
            <span>{{ 'controller.reboot' | translate }}</span>
          </button>
          <button class="popup-action-btn" (click)="onMenuUpdate()" [title]="'controller.update' | translate">
            <img src="assets/icons/update.svg" width="20" height="20" [alt]="'controller.update' | translate" />
            <span>{{ 'controller.update' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Logs Panel (fullscreen) -->
  <div class="logs-overlay" *ngIf="showLogsPanel">
    <div class="logs-fullscreen">
      <div class="logs-panel-header">
        <h3>{{ 'controller.logs.title' | translate }} &mdash; {{ controller?.name }}</h3>
        <div class="logs-panel-actions">
          <button class="log-action-btn" (click)="enableSendLogs()" [title]="'controller.logs.start_hint' | translate">&#9654; {{ 'common.start' | translate }}</button>
          <button class="log-action-btn" (click)="disableSendLogs()" [title]="'controller.logs.stop_hint' | translate">&#9632; {{ 'common.stop' | translate }}</button>
          <button class="log-action-btn" (click)="clearLogs()" [title]="'controller.logs.clear_hint' | translate">{{ 'common.clear' | translate }}</button>
          <button class="log-action-btn log-close-btn" (click)="closeLogs()" [title]="'common.close' | translate">
            <img src="assets/icons/close.svg" width="18" height="18" [alt]="'common.close' | translate" />
          </button>
        </div>
      </div>
      <div class="logs-body" #logsContainer>
        <div *ngIf="logs.length === 0" class="logs-empty">{{ 'controller.logs.empty' | translate }}</div>
        <div *ngFor="let entry of logs" class="log-line" [ngClass]="getLogLevelClass(entry.level)">
          <span class="log-time">{{ entry.timestamp | date:'HH:mm:ss.SSS' }}</span>
          <span class="log-level">[{{ getLogLevelLabel(entry.level) }}]</span>
          <span class="log-msg">{{ entry.message }}</span>
        </div>
      </div>
      <div class="logs-footer">
        <span class="logs-count">{{ 'controller.logs.entries' | translate: { count: logs.length } }}</span>
      </div>
    </div>
  </div>
</div>

<!-- Диалог подтверждения Upload -->
<div class="popup-overlay" *ngIf="showUploadConfirm">
  <div class="modal-dialog">
    <div class="modal-title">{{ 'controller.confirm.upload' | translate }}</div>
    <div class="modal-actions">
      <button (click)="confirmUpload()">{{ 'common.yes' | translate }}</button>
      <button (click)="cancelDialog()">{{ 'common.no' | translate }}</button>
    </div>
  </div>
</div>

<!-- Диалог подтверждения Import (забрать конфиг с устройства) -->
<div class="popup-overlay" *ngIf="showImportConfirm">
  <div class="modal-dialog">
    <div class="modal-title">{{ 'controller.confirm.import' | translate }}</div>
    <div class="modal-actions">
      <button (click)="confirmImport()">{{ 'common.yes' | translate }}</button>
      <button (click)="showImportConfirm = false">{{ 'common.no' | translate }}</button>
    </div>
  </div>
</div>

<!-- Диалог подтверждения Delete -->
<div class="popup-overlay" *ngIf="showDeleteConfirm">
  <div class="modal-dialog">
    <div class="modal-title">{{ 'controller.confirm.delete' | translate }}</div>
    <div class="modal-actions">
      <button (click)="confirmDelete()">{{ 'common.yes' | translate }}</button>
      <button (click)="cancelDialog()">{{ 'common.no' | translate }}</button>
    </div>
  </div>
</div>

<!-- Диалог подтверждения Reboot -->
<div class="popup-overlay" *ngIf="showRebootConfirm">
  <div class="modal-dialog">
    <div class="modal-title">{{ 'controller.confirm.reboot' | translate }}</div>
    <div class="modal-actions">
      <button (click)="confirmReboot()">{{ 'common.yes' | translate }}</button>
      <button (click)="cancelDialog()">{{ 'common.no' | translate }}</button>
    </div>
  </div>
</div>

<!-- Диалог подтверждения Update -->
<div class="popup-overlay" *ngIf="showUpdateConfirm">
  <div class="modal-dialog">
    <div class="modal-title">{{ 'controller.confirm.update' | translate }}</div>
    <div class="modal-actions">
      <button (click)="confirmUpdate()">{{ 'common.yes' | translate }}</button>
      <button (click)="cancelDialog()">{{ 'common.no' | translate }}</button>
    </div>
  </div>
</div>